import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OfferAreaService } from '../../../service/offer-area/offer-area.service';
import { sortObjbyName } from '../../../../../theme/functions/sortObjbyName.function';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectOfferAreaComponent),
  multi: true,
};

@Component({
  selector: 'app-select-offer-area',
  templateUrl: './select-offer-area.component.html',
  styleUrls: ['./select-offer-area.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectOfferAreaComponent implements ControlValueAccessor,OnChanges {
    @Input() offerAreaId: number;
    @Input() offerPrimaryAreaId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public offerAreaOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public offerAreaService: OfferAreaService
    ) {
        this.page = 1;
        this.per_page = 30;
        this.query = undefined;
        this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
    }
    ngOnInit(){
    }
    ngOnChanges(){
        if(this.offerPrimaryAreaId)
        {
            this.filters = [];
            this.filters.push({key: 'offer_primary_area_id', value: String(this.offerPrimaryAreaId)});
            this.getOfferAreas(this.query, this.filters);
        }
    }
    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean ) {
        this.disabled = isDisabled;
    }

    public change($event) {
        this.onMyChange.emit($event.target.value);
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getOfferAreas(query?: string, filters?: any[]) {
        this.offerAreaOptions = [];
        this.offerAreaOptions.push({id: undefined, name: 'choose', offer_primary_area_id: undefined});
                
        this.offerAreaService.getOfferArea(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const offerAreas = sortObjbyName(response.json().data,'asc');
                this.totalRecords = response.json().meta.total;
                
                offerAreas.forEach(element => {
                    if (this.offerAreaId == element.id) {
                        this.offerAreaOptions.push({id: element.id, name: element.name, selected: true, offer_primary_area_id: element.offer_primary_area_id});
                    } 
                    else {
                        this.offerAreaOptions.push({id: element.id, name: element.name, selected: false, offer_primary_area_id: element.offer_primary_area_id});
                    }
                });
                
            },
            error => {
                this.offerAreaOptions = [];
                this.offerAreaOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/offer-areas/select-offer-area/select-offer-area.component.ts